import { FEATURE_TOGGLES } from './../constants';

function createFormHandler() {
    return {
        handleSubmit: (model, reset, invalidate) => {
            log("handling submit", [model, reset, invalidate]);
            if (this.onSubmit) {
                this.onSubmit(model, reset, invalidate);
            }
            else {
                log("WARNING: form was submitted without an onSubmit() specified for formHandler");
            }
        }
    }
}

function fromCamelToSpacedString(value) {
    return value.replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([a-z])/g, ' $1$2')
        .replace(/\ +/g, ' ');
}

function replaceAll(value, find, replace) {
	return value.split(find).join(replace);
}

function getCookie(key) {
	let regex = new RegExp(`${key}=([^;]+)`),
		value = regex.exec(document.cookie);

	// TODO: find out if `decodeUri()` can replace `unescape()` here
	return value ? unescape(value[1]) : null;
}

function getFunctionName(func) {
    if (typeof (func) === 'function') {
        func = func.toString();
    }
    if (typeof (func) !== 'string') {
        return;
    }
    let regex = new RegExp(/function\s+(.*?)\s*\(/),
        matches = regex.exec(func);

    if (matches.length === 2) {
        return matches[1];
    }
    if (matches.length === 1) {
        return matches[0];
    }
    return undefined;
}

function getNestedProps(obj, prefix) {
    let props = Object.keys(obj),
        toFlatten = props.map(prop => {
            isObject(obj[prop]) ? getNestedProps(obj[prop], `${prefix}${prop}_`) : (!prefix ? prop : `${prefix}${prop}`)
        });
    return _.flattenDeep(toFlatten);
}

function getNestedValues(obj) {
    let props = Object.keys(obj);
    return _.flatten(props.map(prop => isObject(obj[prop]) ? getNestedValues(obj[prop], "") :
        (Array.isArray(obj[prop]) && obj[prop].length && isObject(obj[prop][0]) ? `"${encodeURIComponent(JSON.stringify(obj[prop]).replace('null', ''))}"` :
            Array.isArray(obj[prop]) ? `"${JSON.stringify(obj[prop].join('|')).replace(/"/g, '')}"` : `${JSON.stringify(obj[prop]).replace('null', '')}`)));
}

function getUrlParam(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");

    let paramRegex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = paramRegex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getUrlParams(name) {
    const params = new URLSearchParams(location.search);
    const values = params.getAll(name);

    return values || [];
}

function isIE() {
    let ua = window.navigator.userAgent;


    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}

function isFlatObject(obj) {
    if (!obj) {
        return false;
    }

    let keys = Object.keys(obj),
        isFlat = true;
    keys.forEach(key => {
        if (typeof (obj[key]) !== 'object' || obj[key] === null) {
            return;
        }
        isFlat = false;
    });

    return isFlat;
}

function isObject(obj) {
    return {}.toString.apply(obj) === '[object Object]';
}

function ifUndefined(obj, thenValue = false) {
    if (!isUndefined(obj)) {
        return obj;
    }

    return thenValue;
}

function interpolate(text, tokens) {
    return tokens.reduce((output, token) => {
        let key = Object.keys(token)[0];
        return output.split(key).join(token[key]);
    }, text);
}

function isUndefined(obj) {
    return typeof (obj) === 'undefined';
}

function log(msg, params) {
    return console.info(msg, params);
}

function objectPathExists(obj, ...path) {
    return !!path.reduce((_obj, level) => {
        if (!_obj) {
            return;
        }
        return _obj[level];
    }, obj);
}

function quickDiff(obj1, obj2) {
    let diff = {};

    if (isObject(obj1) && !isUndefined(obj2))
        for (let key in obj1) {

            // handle removed
            if (isUndefined(obj2[key]) || (isObject(obj1[key]) && obj1[key] && !obj2[key])) {
                diff["--" + key] = "";
                continue;
            }

            // skip if same
            if (obj1[key] === obj2[key]) {
                continue;
            }

            // handle special case to show id
            if (key === "id") {
                diff[key] = obj2[key];
                continue;
            }

            // handle falsey changing to object
            if (!obj1[key] && obj2[key] && isObject(obj2[key])) {
                diff["++" + key] = "";
                continue;
            }

            // if neither an object, don't recurse
            if (!isObject(obj1[key]) && !isObject(obj2[key])) {
                continue;
            }

            // recurse
            else diff[key] = quickDiff(obj1[key], obj2[key]);
        }
    if (isObject(obj2) && !isUndefined(obj1))
        for (let key in obj2) {

            // Unless the only interest is showing ++ for nested OBJECTS then the isObject check should come out
            if (!isUndefined(obj1[key]) || !obj2[key] || !isObject(obj2[key])) {
                continue;
            }

            if (!obj1[key] && isObject(obj2[key]) && obj2[key]) {
                diff["++" + key] = "";
                continue;
            }
        }

    return diff;
}

function removeCookie(key) {
    setCookie({ key, expireMinutes: -999 });
}

function removeFromArray(array) {
    const arr = array.slice();
    let what, a = arguments, len = a.length, ax;
    while (len > 1 && arr.length) {
        what = a[--len];
        while ((ax = arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}

function resolveObjectPath(obj, ...path) {
    if (!objectPathExists(...arguments)) {
        return undefined;
    }

    return path.reduce((_obj, level) => {
        return _obj[level];
    }, obj);
}

function resolveObjectPathWithRetry(obj, { maxAttempts = 20, interval = 1500 }, ...path) {
    let numAttempts = 0;

    return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            console.log(`Attempting \`resolveObjectToPathWithRetry(${path.join('.')})\` - Attempts: ${numAttempts}`);

            let output = resolveObjectPath(obj, ...path);
            if (typeof (output) !== 'undefined') {
                clearInterval(intervalId);
                resolve(output);
            }

            if (numAttempts++ >= maxAttempts) {
                clearInterval(intervalId);
                reject(`Could not resolve path: ${path} in ${maxAttempts} tries over ${maxAttempts * interval}ms`);
            }

        }, interval);
    });
}

function safeJSONParse(json, def = {}) {
    let obj = def;

    try {
        if (json) {
            obj = JSON.parse(json);
        }
    } catch (err) {
        // TODO: Wrap logger
        console.log(`Error Processing JSON: ${err} => ${json}`);
    }

    return obj;
}

function getDefaultCookieOptions() {
    const options = {};
    if (location.hostname !== 'localhost') {

        options.SameSite = 'None';
        options.Secure = true;

        if (flex.isFeatureToggleEnabled(FEATURE_TOGGLES.USE_FIRST_PARTY_COOKIES)) {
            options.SameSite = 'Lax';
        }
    }

    return options;
}

function setCookie({ expireMinutes, value = '', path = '/', key, options }) {
    let expires = 0,
        cookieValue = isObject(value) ? JSON.stringify(value) : value,
        cookie = `${key}=${cookieValue};`;

    if (expireMinutes) {
        let d = new Date();
        d.setTime(d.getTime() + (expireMinutes * 60 * 1000));
        expires = d.toUTCString();
    }

    if (expires) {
        cookie = `${cookie}expires=${expires};`;
    }

    if (!options) {
        options = getDefaultCookieOptions();
    }

    for (let optionKey in options) {
      if (options.hasOwnProperty(optionKey)) {
        cookie =
          options[optionKey] === true
            ? `${cookie}${optionKey};`
            : `${cookie}${optionKey}=${options[optionKey]};`;
      }
    }

    cookie = `${cookie}path=${path}`;

    document.cookie = cookie;
}

function startsWith(target, searchString, position = 0) {
    if (typeof (target) !== 'string') {
        return false;
    }
    return target.substr(position, searchString.length) === searchString;
}

function isValidRegExp(value) {
    var isValid = true;
    try {
        new RegExp(value);
    } catch (e) {
        isValid = false;
    }

    return isValid;
}

function toCsv({ data = [], excludeHeader = false, inline = false, existing = '' }) {
    if (!data.length) {
        return '';
    }
    let csv = data.map(row => getNestedValues(row));

    if (!excludeHeader) {
        csv.unshift(getNestedProps(data[0]));
    }
    if (!inline) {
        csv = csv.join('\r\n');
    }

    return existing + csv;
}

// Dependent on JS Math.random() randomness with is mostly random.
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

function getLogoutUrl(flex) {
    const { session = {} } = flex.getStore();

    return session.oAuthToken &&
        !session.createdByInternalCall &&
        flex.isFeatureToggleEnabled(FEATURE_TOGGLES.USE_SINGLE_LOGOUT)
        ? '/singlelogout'
        : '/logout';
}

function redirectToDefaultPage(path = '/login') {
    const store = flex.getStore();
    const { isDevMode } = store.appContext;

    const targetPath = isDevMode ? path : location.origin;

    flex.redirect(targetPath);
}

module.exports = {
    createFormHandler,
    fromCamelToSpacedString,
	getCookie,
    replaceAll,
    getFunctionName,
    getNestedProps,
    getNestedValues,
    getUrlParam,
    getUrlParams,
    ifUndefined,
    interpolate,
    isObject,
    isFlatObject,
    isIE,
    isUndefined,
    log,
    objectPathExists,
    quickDiff,
    removeCookie,
    isValidRegExp,
    removeFromArray,
    resolveObjectPath,
    resolveObjectPathWithRetry,
    safeJSONParse,
    setCookie,
    startsWith,
    toCsv,
    uuid,
    getLogoutUrl,
    redirectToDefaultPage
};